import { IRenderIconType, useRenderIconType } from './utils';

export const PaymentIcon = ({
  method,
  isMediumSize = false,
  isLargeSize = false,
  isNoBorder = false,
  showGenericIcon = false,
}: IRenderIconType) => {
  const renderIcon = useRenderIconType({
    method,
    isMediumSize,
    isLargeSize,
    isNoBorder,
    showGenericIcon,
  });

  return <>{renderIcon()}</>;
};
